import { Link } from "react-router-dom";
import {ProjectsListAR} from './projectsData.js';
import {ProjectsListEN} from './projectsData.js'
import { useLanguage } from '../context/LanguageContext.js';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export default function ProjectPage(){
    const {language} = useLanguage();
    const ProjectsList=language==="en"?ProjectsListEN:ProjectsListAR
    const location = useLocation();
    const canonicalUrl = window.location.origin + location.pathname;
    const ProjectShow=ProjectsList.map((project)=>{
        return<div className="projectPage-card" key={project.id}>
<div className="projectPage-card-img">
    <img src={project.img} alt="no-image"/>
</div>
<div className="projectPage-description-div">
<h4>{project.title}</h4>
<p>{project.description}</p>
</div>
        </div>
        
        
    });
    return <div className="container">
        <Helmet>
        <title>ام بي تك - Mptech  أعمال </title>
        <link rel="canonical" href={canonicalUrl} />
         <meta 
          name="description" 
          content="هذه الصفحة يوضع فيها نبذة من الأعمال التي تقوم بها الشركة وقد وضع فيها، LglTech وهو نظام تقني متكامل يخدم قطاع القانون، موقع لمتجر أحذية وشنط ،التسويق بالمحتوى، موقع لحجز الاستشارات"
        />
        <meta 
          name="keywords" 
          content="خدمات تقنية 
وكالة تسويق رقمي 
تسويق إلكتروني
المحامي الذكي
تصميم شعار
مواقع إلكترونية
تصميم تطبيقات
مصور تغطيات إعلامية
صيانة برمجيات
حملات بريد الكتروني
مصور افنت
تصميم تطبيقات للكمبيوتر
نظام محاسبي
اي ار بي
ERP
موقع تعريفي
صناعة موقع كبير
تحسين محركات البحث
ام بي تك
شركة تسويق في جدة
شركة تقنية في جدة
كيف اسوق لمشروعي في الانستقرام
سعر تصميم السوشيال ميديا في السعودية 
شروط البيع في انستقرام داخل السعودية 
نموذج خطة تسويقية
كيفية تسويق المنتج اون لاين"
        />
        </Helmet>
        <div className="projectPage-conatiner" >
        {ProjectShow}
        </div>
        
    </div>
}